import React from 'react';
import Obfuscate from "react-obfuscate";

export function EmailLink(props) {
  return (
    <Obfuscate email={props.email}>{props.children}</Obfuscate>
  );
}
